import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Iconify from '../iconify';
import { GetBranches, GetDepartments, GetRoles, GetUserCompanies, PostUser } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';



const AddUser = (props) => {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const nameRef = useRef('');
  const userNameRef = useRef('');
  const passwordRef = useRef('');
  const userEmailRef = useRef('');
  const userRoleRef = useRef('');
  const [isActive, setIsActive] = useState(true);
  const [userCompanies, setUserCompanies] = useState([]);
  const fetchRoles = async (event) => {
    const roles = await GetRoles();
    const departments = await GetDepartments();
    const savedBranches = await GetBranches();
    const companies = await GetUserCompanies();
    setRoles(roles);
    setDepartments(departments);
    setBranches(savedBranches);
    setUserCompanies(companies);
    setLoading(false);
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    // setPosting(true);
    event.preventDefault();
    console.log('saveHit');
    const payload = {
      name: nameRef.current.value,
      username: userNameRef.current.value,
      password: passwordRef.current.value,
      userEmail: userEmailRef.current.value,
      userRoleId: selectedRole.key,
      deptId: selectedDepartment.key,
      isActive: isActive,
      branchCode: selectedBranch?.prcCode,
      branchName: selectedBranch?.prcName,
      userCompanyId: selectedCompany?.id,
    };

    //console.log(payload);
    let response = await PostUser(payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setMessage(response.data);
      setSaved(true);
      setOpen(true);
      setTimeout(() => {
        navigate('/app/user');
      }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeActive = (event) => {
    setIsActive(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title> Add User | Immigration System </title>
      </Helmet>
      <Container>
        <form onSubmit={SaveUser}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              User
            </Typography>
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button type="submit" variant="contained">
                Create
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField label="Name" required variant="outlined" fullWidth size="small" inputRef={nameRef} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Username"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={userNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Password"
                        required
                        type="password"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={passwordRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Email"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={userEmailRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="role"
                        size="small"
                        options={roles}
                        getOptionLabel={(role) => role.value}
                        renderInput={(params) => (
                          <TextField required {...params} inputRef={userRoleRef} label="Role" variant="outlined" />
                        )}
                        onChange={(event, role) => setSelectedRole(role)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="department"
                        size="small"
                        options={departments}
                        getOptionLabel={(department) => department.value}
                        renderInput={(params) => (
                          <TextField required {...params} label="Department" variant="outlined" />
                        )}
                        onChange={(event, department) => setSelectedDepartment(department)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="branch"
                        size="small"
                        options={branches}
                        getOptionLabel={(branch) => branch.prcName}
                        renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
                        onChange={(event, branch) => setSelectedBranch(branch)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="userCompanies"
                        size="small"
                        options={userCompanies}
                        getOptionLabel={(company) => company.name}
                        renderInput={(params) => <TextField required {...params} label="Company" variant="outlined" />}
                        onChange={(event, company) => setSelectedCompany(company)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={isActive}
                          onChange={handleChangeActive}
                          row
                        >
                          <FormControlLabel value={true} control={<Radio />} label="Active" />
                          <FormControlLabel value={false} control={<Radio />} label="In Active" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
    </>
  );

  //   return <>User</>;
};

export default AddUser;

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

// const DimensionAutocomplete = ({ label, options, onChange }) => {
//   return (
//     <Autocomplete
//       id={label}
//       size="small"
//       freeSolo
//       options={options}
//       getOptionLabel={(option) => option.prcName}
//       renderInput={(params) => <TextField required {...params} label={label} variant="outlined" />}
//       onChange={(event, value) => onChange(value)}
//     />
//   );
// };
